<script>
  let promise = false
  let y = 0

  let mainContent = 0

  import { onMount } from 'svelte'

  import Scroller from '@sveltejs/svelte-scroller'
  import Footer from '../components/Footer.svelte'
  import narrative from '../data/narrative.json'
  import Heatmap from '../components/Heatmap.svelte'
  import TweetLine from '../components/TweetLine.svelte'
  import fjztweets from '../data/tweets-fjz.json'
  import freejzline from '../data/freejz-line.json'
  import kznshutdownhm from '../data/kznshutdown-hm.json'
  import gautengshutdownhm from '../data/gautengshutdown-hm.json'
  import phoenixmassacrehm from '../data/phoenixmassacre-hm.json'
  import kznshutdownline from '../data/kznshutdownline.json'
  import shutdowngpline from '../data/shutdowngpline.json'
  import phoenixline from '../data/phoenixline.json'
  import Map from '../components/Map.svelte'
  import TweetCharts from '../components/TweetCharts.svelte'
  import TweetBox from '../components/TweetBox.svelte'
  import ActiveUsers from '../components/ActiveUsers.svelte'
  import ActiveUsersFJZ from '../components/ActiveUsersFJZ.svelte'
  import ActiveUsersGauteng from '../components/ActiveUsersGauteng.svelte'
  import ActiveUsersPhoenix from '../components/ActiveUsersPhoenix.svelte'

  let sidebar = []
  let sidebarLive = []
  let sidebarDate = ''
  async function getSidebar() {
    await fetch(
      'https://api.datadesk.co.za/csvjson.php?table=dd_social_sidebar_4790104'
    )
      .then((response) => response.json())
      .then((response) => {
        sidebar = response
        sidebarLive = response
        promise = true
      })
  }

  let index, offset, progress

  $: if (index) {
    setTimeout(() => {
      sidebarLive = sidebar.filter((d) => d.date === sidebarDate)
    })
  }

  import NarrativeSection from '../components/NarrativeSection.svelte'

  function playVideo(id) {
    // get status
    if (document.getElementById(id).paused) {
      document.getElementById(id).play()
      document.querySelector(`#vp${id}`).style.display = 'none'
    } else {
      document.getElementById(id).pause()
      document.querySelector(`#vp${id}`).style.display = 'block'
    }
  }
  onMount(() => {
    mainContent = document.querySelector('.content-wrap').offsetTop
  })
</script>

<svelte:window bind:scrollY={y} />
<section class="wide">
  <Map />
</section>
<section class="introduction">{narrative.about}</section>

<Scroller top={0} bottom={0.8} bind:index bind:offset bind:progress>
  <div class="background-holder" slot="background">
    <div class="timeline-back" />
  </div>

  <div class="foreground" slot="foreground">
    <div class="content-wrap">
      <div class="chart-title"><h2>40,000 Tweets</h2></div>

      <section>
        <NarrativeSection currentSection={narrative.section00} sectionNo="00" />
      </section>

      <section class="wide" style="height: 450px;"><TweetCharts /></section>

      <section>
        <div class="chart-title"><h2>Four Hashtags</h2></div>
      </section>

      <section style="margin-bottom: 20px;">
        <NarrativeSection currentSection={narrative.section01} sectionNo="01" />
      </section>

      <section class="line-chart-wrap">
        <TweetLine
          data={freejzline}
          dataKZN={kznshutdownline}
          dataGP={shutdowngpline}
          dataPhoenix={phoenixline}
        />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section0} sectionNo="0" />
      </section>
      <div class="spacer">&nbsp;</div>
      <section style="text-align: center;">
        <img src="/images/estcourt.svg" alt="Map of Nkandla and Estcourt" />
      </section>
      <div class="spacer">&nbsp;</div>
      <section>
        <NarrativeSection
          currentSection={narrative.section001}
          sectionNo="001"
        />
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/LandDilemma/status/1412922175821164547"
          target="_blank"><img src="/images/tweet1.png" alt="First tweet" /></a
        >
      </section>

      <section>
        <NarrativeSection
          currentSection={narrative.section002}
          sectionNo="002"
        />
      </section>

      <section>
        <NarrativeSection
          currentSection={narrative.section003}
          sectionNo="003"
        />
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/_AfricanSoil/status/1413145441940611074"
          target="_blank"
          ><img src="/images/image01.png" alt="Second tweet" /></a
        >
      </section>

      <section class="wide half-wide">
        <div id="vpvideo1" class="video-play" />

        <video controls id="video1" width="100%" poster="/images/video1bw.jpg">
          <source
            src="https://hosted.mediahack.co.za/looting/video/8july-umvoti-toll-plaza.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div class="video-description">
          Protestors block both ends of the uMvoti toll gate on the N2 at around
          4pm on Thursday, 8 July. Source: <a
            href="https://twitter.com/mukanya_shoko/status/1413141332395057164"
            >@mukanya_shoko</a
          >
        </div>
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section1} sectionNo="1" />
      </section>

      <section>
        <NarrativeSection
          currentSection={narrative.section1001}
          sectionNo="1001"
        />
      </section>

      <section>
        <Heatmap
          tweets={fjztweets}
          label="Number of tweets with the #FreeJacobZuma hashtag"
          aid="a1"
          atext="Jacob Zuma arrested"
          atarget="b-10"
        />
      </section>
      <section>
        <div class="chart-title">
          <h2>Most active users on #FreeJacobZuma hashtag</h2>
        </div>
      </section>
      <section class="line-chart-wrap active-users">
        <ActiveUsersFJZ />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section2} sectionNo="2" />
      </section>

      <section class="wide half-wide">
        <div id="vpvideo1" class="video-play" />

        <video controls id="video2" width="100%">
          <source
            src="https://hosted.mediahack.co.za/looting/video/9july-trucks-2.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div class="video-description">
          Video of trucks on fire at Mooi River toll plaza. Source: <a
            href="https://twitter.com/siphamandlagoge/status/1413609594274914304"
            target="_blank">@SiphamandlaGoge</a
          >
        </div>
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section21} sectionNo="21" />
      </section>
      <section class="inline-image">
        <a
          href="https://twitter.com/DZumaSambudla/status/1413604399805571075"
          target="_blank"
        >
          <img src="/images/image2.png" alt="Tweet" /></a
        >
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section22} sectionNo="22" />
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/AzaniaIzweLethu/status/1413384330584498177"
          target="_blank"
          ><img src="/images/poster-1.png" alt="KZN Shutdown Poster" /></a
        >
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section23} sectionNo="23" />
      </section>

      <!-- <section>
        The hashtag #KZNShutdown started to feature on Friday, 9 July and
        continued to be widely used until Tuesday, 12 July
      </section>

      <section>
        At 8.30am on 9 July the poster was tweeted again by a different user. It
        was clear by now that the shutdowns had begun:
      </section> -->

      <section>
        <Heatmap
          tweets={kznshutdownhm}
          label="Number of tweets using the #KZNShutdown hashtag"
          aid="a2"
          atext="Major roads blocked in Durban"
          atarget="b-9"
        />
      </section>

      <section>
        <div class="chart-title">
          <h2>Most active users on #KZNShutdown hashtag</h2>
        </div>
      </section>
      <section class="line-chart-wrap active-users">
        <ActiveUsers />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section3} sectionNo="3" />
      </section>

      <section style="text-align: center;">
        <div id="vpvideo3" class="video-play" />

        <video controls id="video3" width="80%">
          <source
            src="https://hosted.mediahack.co.za/looting/video/12july-looting-durban.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div class="video-description">
          Looters use bakkies, trolleys and forklifts to transport goods stolen
          from warehouses in Durban on 12 July. Source: <a
            href="https://twitter.com/als2010/status/1414464752491827203"
            target="_blank">@als2010</a
          >
        </div>
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section31} sectionNo="31" />
      </section>

      <section style="text-align: center;">
        <div id="vpvideo4" class="video-play" />

        <video controls id="video4" width="100%">
          <source
            src="https://hosted.mediahack.co.za/looting/video/13july-upl.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div class="video-description">
          Source: <a
            href="https://twitter.com/Newzroom405/status/1414899593041547265](https://twitter.com/Newzroom405/status/1414899593041547265"
            target="_blank">@Newsroom405</a
          >
        </div>
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section4} sectionNo="4" />
      </section>

      <section class="inline-image ">
        <a
          href="https://twitter.com/Izwe_Lethu_2020/status/1413420644948226048"
          target="_blank"
        >
          <img src="/images/gauteng-pic-1.png" alt="Gauteng Shutdown Tweet" />
        </a>
      </section>

      <section>
        <Heatmap
          tweets={gautengshutdownhm}
          label="#GautengShutdown"
          aid="a3"
          atext="An annotation"
          atarget="e-18"
        />
      </section>

      <section>
        More tweets of a similar nature, calling for the removal of President
        Cyril Ramaphosa, were to follow on Saturday.
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/IndWorldThinker/status/1413755208929136641"
          target="_blank"
          ><img src="/images/gauteng-pic2.png" alt="Gauteng Tweet" /></a
        >
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/Thembeni_Mabuza/status/1413757476856606720"
          target="_blank"
          ><img src="/images/gauteng-pic3.png" alt="Gauteng Tweet" /></a
        >
      </section>

      <section>
        What was described as a “programme of action against unjust behaviour of
        the South African Courts” was tweeted at 9.29am. It contained a list of
        12 major roads in Gauteng that were to be shutdown. It also suggested
        that “comrades who are far from major roads” should “close all entrances
        to city centres and economy hubs”.
      </section>

      <section class="inline-image">
        <a
          href="https://twitter.com/Izwe_Lethu_2020/status/1413762340382720003"
          target="_blank"
          ><img
            src="/images/gauteng-pic4.png"
            alt="Gauteng Shutdown Tweet"
          /></a
        >
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section41} sectionNo="41" />
      </section>

      <section>
        <div class="chart-title">
          <h2>Most active users on #GautengShutdown hashtag</h2>
        </div>
      </section>
      <section class="active-users">
        <ActiveUsersGauteng />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section5} sectionNo="5" />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section6} sectionNo="6" />
      </section>

      <section>
        <NarrativeSection currentSection={narrative.section7} sectionNo="7" />
      </section>

      <section>
        <Heatmap
          tweets={phoenixmassacrehm}
          label="Number for tweets using the #PhoenixMassacre hashtag"
          aid="a4"
          atext="An annotation"
          atarget="e-18"
        />
      </section>

      <section>
        <div class="chart-title">
          <h2>Most active users on #PhoenixMassacre hashtag</h2>
        </div>
      </section>
      <section class="active-users">
        <ActiveUsersPhoenix />
      </section>

      <Footer />
    </div>
  </div>
</Scroller>

<style>
  video {
    cursor: pointer;
  }
  .timeline-back {
    max-width: 300px;
    /* background: red; */
    /* margin-left: 30px; */
    min-height: 100vh;
    font-weight: 700;
    font-size: 1.3rem;
    /* border: dotted 1px gray; */
  }

  .background-holder {
    padding-top: 10px;
    background: rgb(26, 26, 26);
    z-index: -500;
  }

  .video-description {
    max-width: 600px;
    color: rgb(209, 209, 209);
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    /* background: rgba(0, 0, 0, 0.678); */
    font-style: italic;
  }
  .video-play {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    text-align: center;
    cursor: pointer;
    /* background: #fff; */
    z-index: 200;
    pointer-events: none;
  }

  .video-play img {
    opacity: 0.7;
    cursor: pointer;
    width: 100px;
  }
  .video-play img:hover {
    opacity: 1;
  }
  section {
    position: relative;
  }
  .about {
    line-height: 1.7rem;
    margin-top: 100px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    font-weight: 500;
  }
  .introduction {
    margin-top: 10px;
  }
  .line-chart-wrap {
    max-width: 75%;
    padding-left: 5%;
    padding-right: 5%;
  }

  .active-users {
    /* max-width: 700px; */
  }
  @media only screen and (max-width: 800px) {
    .line-chart-wrap {
      max-width: 90%;
    }
    .video-description {
      font-size: 0.8rem;
      padding: 5px;
    }
    .crosshead-inner-content {
      font-size: 0.5rem;
    }
    .active-users {
      max-width: 400px;
      /* padding: 0px; */
    }
  }
</style>
